import { render, staticRenderFns } from "./MultilineChip.vue?vue&type=template&id=17fab597"
import script from "./MultilineChip.vue?vue&type=script&lang=js"
export * from "./MultilineChip.vue?vue&type=script&lang=js"
import style0 from "./MultilineChip.vue?vue&type=style&index=0&id=17fab597&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports